
export default [
  {
    path: 'contabilidad',
    name: 'empresa.sucursal.contabilidad',
    redirect: { name: 'empresa.sucursal.formaspago' },
    component: () => import('@/views/empresa/sucursales/contabilidad/SucursalContabilidad.vue'),
    children: [
      {
        path: 'formas-de-pago',
        name: 'empresa.sucursal.formaspago',
        component: () => import('@/views/empresa/sucursales/contabilidad/SucursalContabilidadFormasDePago.vue'),
      },
      {
        path: 'formas-de-pago/registrar',
        name: 'empresa.sucursal.formaspago.registrar',
        component: () => import('@/views/empresa/sucursales/contabilidad/SucursalContabilidadFormasDePagoRegistrar.vue'),
      },
      {
        path: 'reportes',
        name: 'empresa.contabilidadReportes',
        component: () => import('@/views/admin/sucursales/contabilidad/ContabilidadReportesHome.vue'),
      },
      {
        path: 'cuentas-por-defecto',
        name: 'empresa.sucursal.cuentas.defecto',
        component: () => import('@/views/contabilidad/ContabilidadCuentasDefecto.vue'),
      },
      {
        path: 'plancuentas',
        name: 'empresa.sucursal.contabilidad.plancuentas',
        component: () => import('@/views/empresa/sucursales/contabilidad/SucursalContabilidadPlanDeCuentas.vue'),
      },

      {
        path: 'asientos',
        name: 'empresa.sucursal.asientos',
        component: () => import('@/views/empresa/sucursales/contabilidad/SucursalContabilidadAsientoHome.vue'),
      },

      {
        path: 'asiento/mantenimiento',
        name: 'empresa.sucursal.asientoMantenimiento',
        component: () => import('@/views/contabilidad/asiento/manenimiento/MantenimientoAsientoView.vue'),
      },
      {
        path: 'asiento/mantenimiento/registrar',
        name: 'empresa.sucursal.asientoMantenimientoRegistrar',
        component: () => import('@/views/empresa/sucursales/contabilidad/manenimiento/MantenimientoAsientoRegistrarView.vue'),
      },
      {
        path: 'asiento/mantenimiento/editar/:numero?',
        name: 'empresa.sucursal.asientoMantenimientoUpdate',
        component: () => import('@/views/empresa/sucursales/contabilidad/manenimiento/MantenimientoAsientoUpdateView.vue'),
      },
      {
        path: 'asientotipo',
        name: 'empresa.sucursal.asientoTipo',
        component: () => import('@/views/contabilidad/asiento/asientotipo/AsientoTipoView.vue'),
      },
      {
        path: 'asientotipo/registrar',
        name: 'empresa.sucursal.asientoTipoRegistrar',
        component: () => import('@/views/contabilidad/asiento/asientotipo/AsientoTipoRegistrarView.vue'),
      },
      {
        path: 'asientotipo/editar',
        name: 'empresa.sucursal.asientoTipoUpdate',
        component: () => import('@/views/contabilidad/asiento/asientotipo/AsientoTipoUpdateView.vue'),
      },
      {
        path: 'rubros',
        name: 'empresa.sucursal.contabilidad.rubros',
        component: () => import('@/views/empresa/sucursales/contabilidad/rubros/SucursalContabilidadRubrosHome.vue'),
      },
      {
        path: 'rubroventa/registrar',
        name: 'empresa.sucursal.contabilidad.rubroventa.registrar',
        component: () => import('@/views/empresa/sucursales/contabilidad/rubros/venta/ContabilidadRubroVentaRegistrar.vue'),
      },
      {
        path: 'rubroventa/editar',
        name: 'empresa.sucursal.contabilidad.rubroventa.update',
        component: () => import('@/views/empresa/sucursales/contabilidad/rubros/venta/ContabilidadRubroVentaUpdate.vue'),
      },
      {
        path: 'rubrocompra/registrar',
        name: 'empresa.sucursal.contabilidad.rubrocompra.registrar',
        component: () => import('@/views/empresa/sucursales/contabilidad/rubros/compra/ContabilidadRubroCompraRegistrar.vue'),
      },
      {
        path: 'rubrocompra/editar',
        name: 'empresa.sucursal.contabilidad.rubrocompra.update',
        component: () => import('@/views/empresa/sucursales/contabilidad/rubros/compra/ContabilidadRubroCompraUpdate.vue'),
      },
      {
        path: 'contabilidadValidar',
        name: 'empresa.sucursal.contabilidadValidar',
        component: () => import('@/components/sucursal/contabilidad/SucursalContabilidad.vue'),
      },
      {
        path: 'alertas-psp',
        name: 'empresa.sucursal.contabilidad.alertas-psp',
        component: () => import('@/views/empresa/sucursales/contabilidad/SucursalContabilidadAlertasPSP.vue'),
      },
    ],
  },


];